import dynamic from 'next/dynamic';

const Synthesizer = dynamic(() => import('./Synthesizer'));

export default Synthesizer;
